import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'

import { concatAll } from 'ramda-adjunct'

import { appointmentsRoutes } from '@app/modules/Appointments'
import { auditReportsRoutes } from '@app/modules/AuditReports'
import { authRoutes, AuthSelectors, getLoginPath } from '@app/modules/Auth'
import { clientsProfileRoutes } from '@app/modules/ClientsProfile'
import { courtCasesRoutes } from '@app/modules/CourtCases'
import { courtCasesTablesRoutes } from '@app/modules/CourtCasesTables'
import { clientsListRoutes } from '@app/modules/CustomerList'
import { latestInteractionsRoutes } from '@app/modules/LatestInteractions'
import { messagesRoutes } from '@app/modules/Messages'
import { getOverviewPath, overviewPageRoutes } from '@app/modules/Overview'
import { postponedLetterRequestsRoutes } from '@app/modules/PostponedLetterRequests'
import { printViewRoutes } from '@app/modules/PrintView'
import { statsRoutes } from '@app/modules/StatsDashboard'

import { IRoute } from './IRoute'

export function Router() {
  const isAuthorized = useSelector(AuthSelectors.isAuthorized)
  const authorizedRoutes: IRoute[] = concatAll<IRoute[]>([
    appointmentsRoutes,
    auditReportsRoutes,
    clientsListRoutes,
    clientsProfileRoutes,
    courtCasesTablesRoutes,
    courtCasesRoutes,
    messagesRoutes,
    overviewPageRoutes,
    postponedLetterRequestsRoutes,
    statsRoutes,
    latestInteractionsRoutes,
    printViewRoutes
  ]) as IRoute[]

  return (
    <Switch>
      {isAuthorized &&
        authorizedRoutes.map(({ path, component: Component, exact }) => (
          <Route
            exact={exact}
            key={path}
            path={path}
            render={(props) => <Component {...props} />}
          />
        ))}
      {!isAuthorized &&
        authRoutes.map(({ path, component: Component, exact }) => (
          <Route
            exact={exact}
            key={path}
            path={path}
            render={(props) => <Component {...props} />}
          />
        ))}
      <Redirect to={isAuthorized ? getOverviewPath() : getLoginPath()} />
    </Switch>
  )
}
